import { render } from "./AddKategoriProduk.vue?vue&type=template&id=360c7fa0"
import script from "./AddKategoriProduk.vue?vue&type=script&lang=js"
export * from "./AddKategoriProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__